import validate from "/var/lib/jenkins/workspace/mdm.softminds.net/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/mdm.softminds.net/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/middleware/auth.ts")
}